import React from "react";

const VisibleError = ({ show, name }) => {
  return (
    <span
      style={{
        visibility: show ? "visible" : "hidden",
        fontSize: "13px",
        color: "red",
        paddingLeft: "6px",
        textAlign: "center",
      }}
    >
      {`Please Enter ${name}`}
    </span>
  );
};

export default VisibleError;
